/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuTypeaheadContainer_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedRefineMenuRadioSelectSearch_viewer$ref: FragmentReference;
export type SbSharedRefineMenuRadioSelectSearch_viewer = {|
  +$fragmentRefs: SbSharedRefineMenuTypeaheadContainer_viewer$ref,
  +$refType: SbSharedRefineMenuRadioSelectSearch_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuRadioSelectSearch_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuTypeaheadContainer_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '7f4ab4b9bb82a100a696e1ed031ed2e1';
module.exports = node;
